/**
 * T099: useDeleteTag Hook
 * Mutation hook for deleting tags with warning for assigned prompts
 */

import { useMutation, useQueryClient } from '@tanstack/react-query'
import { deleteTag } from '@/services/tags'
import { queryKeys } from '@/lib/query-keys'

export function useDeleteTag() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (id: string) => deleteTag(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.tags.all })
      // Also invalidate prompts as they may have been affected
      queryClient.invalidateQueries({ queryKey: queryKeys.prompts.lists() })
    },
  })
}
